// src/components/PlatformStatus.jsx
// Shows Etsy/eBay connection status and connect/disconnect buttons

import { connectEtsy, connectEbay, disconnectPlatform } from "../lib/api";

export default function PlatformStatus({ status, onDisconnect }) {
  const platforms = [
    {
      key: "etsy",
      name: "Etsy",
      color: "#F1641E",
      icon: "E",
      connect: connectEtsy,
      description: "Auto-post vintage & curated items",
    },
    {
      key: "ebay",
      name: "eBay",
      color: "#0064D2",
      icon: "e",
      connect: connectEbay,
      description: "Auto-post with full auction support",
    },
  ];

  return (
    <div className="platform-status-grid">
      {platforms.map(p => {
        const connected = status?.[p.key];
        return (
          <div key={p.key} className={`platform-status-card ${connected ? "connected" : ""}`}>
            <div className="psc-left">
              <div className="psc-icon" style={{ background: p.color }}>{p.icon}</div>
              <div>
                <div className="psc-name">{p.name}</div>
                <div className="psc-desc">{connected ? "Connected — ready to post" : p.description}</div>
              </div>
            </div>
            {connected ? (
              <button
                className="psc-btn disconnect"
                onClick={async () => {
                  await disconnectPlatform(p.key);
                  onDisconnect();
                }}
              >
                Disconnect
              </button>
            ) : (
              <button className="psc-btn connect" onClick={p.connect} style={{ borderColor: p.color, color: p.color }}>
                Connect →
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
